import './index.css';
import { useCallback, useState } from 'react';
import { RoomSelector } from '../roomSelector';
import { BookingSessionTable } from '../bookingSessionTable';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectRoom, setRoom } from '../../app/bookingSlice';
import { useTranslation } from 'react-i18next';
import { BookingActivity } from 'api-types/models/Booking';
import { useGetBookingActivitiesQuery } from '../../api/bookingApi';
import { AddBookingActivityModal } from 'components/addBookingSessionModal';

interface IProps {
    rooms: string[];
}

export function BookingSessions({ rooms }: Readonly<IProps>) {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const selectedRoom = useAppSelector(selectRoom);

    const { data: activities = [] } = useGetBookingActivitiesQuery(
        selectedRoom,
        { skip: !selectedRoom }
    );
    const [isAddBookingSessionModalOpen, setIsAddBookingSessionModalOpen] =
        useState(false);
    const [selectedSession, setSelectedSession] = useState<BookingActivity>();

    const closeModal = useCallback(() => {
        setIsAddBookingSessionModalOpen(false);
        setSelectedSession(undefined);
    }, []);

    const openEditSessionModal = useCallback((session: BookingActivity) => {
        setSelectedSession(session);
        setIsAddBookingSessionModalOpen(true);
    }, []);

    return (
        <div className='booking-service'>
            <div className='service-header'>
                <div className='title'>
                    <h2>{t('sessions_added')}</h2>
                    <button
                        className='btn btn-gray'
                        onClick={() => setIsAddBookingSessionModalOpen(true)}
                    >
                        + {t('add')}
                    </button>
                </div>
                <div className='actions'>
                    <RoomSelector
                        rooms={rooms}
                        selectedRoom={selectedRoom}
                        setValue={(room) => dispatch(setRoom(room))}
                    />
                </div>
            </div>

            <BookingSessionTable
                sessions={activities}
                openEditModal={openEditSessionModal}
            />
            {isAddBookingSessionModalOpen && (
                <AddBookingActivityModal
                    closeModal={closeModal}
                    activity={selectedSession}
                    rooms={rooms}
                />
            )}
        </div>
    );
}
